/* kido-track.js — サイト内の行動を、名前の入らない番号で控える（2026-10-04・Issue #187）
   守り：表示を止めない・ページを重くしない
   ・読み込みは defer。動き出すのは表示が終わってひまになってから（requestIdleCallback）
   ・すべて try で包む。ここで何が起きても、サイトの動きには触らない
   ・送るのは sendBeacon（返事を待たない）。受け口が止まっていても何も起きない
   ・個人情報（名前・メール・電話・入力内容）は読まない・送らない */
(function () {
  try {
    var U = 'https://karte.kidomeimoku.co.jp/t';
    var LS = window.localStorage;
    // 先行の試しでは、?kt=1 で開いた端末だけ動かす（お客様の記録はまだ取らない）
    var GATE = false;   // 2026-10-04 プライバシーポリシー改定のうえ全ページへ（代表がテーマを直接修正）
    if (GATE) {
      if (/[?&]kt=1/.test(location.search)) { try { LS.setItem('kt_on', '1'); } catch (e) {} }
      var on = false; try { on = LS.getItem('kt_on') === '1'; } catch (e) {}
      if (!on) return;
    }
    if (!navigator.sendBeacon) return;
    function g(k) { try { return LS.getItem(k); } catch (e) { return null; } }
    function s(k, v) { try { LS.setItem(k, v); } catch (e) {} }
    function rid() { return (Date.now().toString(36) + Math.random().toString(36).slice(2, 10)); }
    var now = Date.now();
    var V = g('kt_v'); if (!V) { V = rid(); s('kt_v', V); }
    // 訪問：前の操作から30分あいたら、新しい訪問として数える
    var last = +(g('kt_t') || 0), S = g('kt_s'), N = +(g('kt_n') || 0), fresh = false;
    if (!S || now - last > 1800000) { S = rid(); N += 1; fresh = true; s('kt_s', S); s('kt_n', String(N)); }
    s('kt_t', String(now));
    var P = location.pathname;
    var K = rid();      // このページを開いた1回の番号（同じ訪問で同じページを2回開いても分けて数える）
    // 社内の端末の印：?kt_staff=1 で一度開くと、その端末の記録は「社内」として数えない
    if (/[?&]kt_staff=1/.test(location.search)) s('kt_staff', '1');
    var STAFF = g('kt_staff') === '1';
    // 細かい記録（すべての押下・見えた区画・困ったときのサイン・表示の速さ。2026-10-24・Issue #193）。
    // まず試験の商品だけで動かす。?kt2=1 で開いた端末もその場で動く（社内の確認用）
    if (/[?&]kt2=1/.test(location.search)) s('kt_v2', '1');
    var V2 = /^(\/collections\/[^/]+)?\/products\/[^/]+\/?$/.test(P) || g('kt_v2') === '1';   // 2026-10-27 d2637-tochi での先行試験を終え、全商品ページへ（承認後に本番へ）
    var C = /\/products\//.test(P) ? 'product' : /^\/collections\/[^/]+\/?$/.test(P) ? 'collection'
      : P === '/' ? 'top' : /^\/pages\//.test(P) ? 'page' : /^\/blogs\//.test(P) ? 'blog'
      : /^\/cart/.test(P) ? 'cart' : /^\/search/.test(P) ? 'search' : 'other';
    var Q = [], timer = null;
    // 受け口は1回4KBまで・20件まで。超えると丸ごと捨てられるので、3.5KB以内に分けて送る
    function flush() {
      timer = null;
      try {
        while (Q.length) {
          var b = [], len = 2;
          while (Q.length && b.length < 20) {
            var one = JSON.stringify(Q[0]);
            if (b.length && len + one.length + 1 > 3500) break;
            b.push(Q.shift()); len += one.length + 1;
          }
          navigator.sendBeacon(U, new Blob(['[' + b.map(function (o) { return JSON.stringify(o); }).join(',') + ']'], { type: 'text/plain' }));
        }
      } catch (e) {}
    }
    function log(e, x) {
      try {
        s('kt_t', String(Date.now()));
        Q.push({ v: V, s: S, n: N, k: K, e: e, p: P, c: C, x: x || undefined });
        if (!timer) timer = setTimeout(flush, 1500);
      } catch (e2) {}
    }
    function start() {
      try {
        var ref = document.referrer || '', ext = ref && ref.indexOf(location.host) < 0;
        var q = (location.search.match(/(utm_[a-z]+|gclid|fbclid|ttclid|igshid)=[^&]*/g) || []).join('&');
        // アプリの中で開いたか（Instagram・Facebook・LINE・TikTok などは、入口を送ってこないことが多い）。
        // 端末の詳しい情報は送らず、アプリの名前だけを送る
        var ua = navigator.userAgent || '', app = /Instagram/.test(ua) ? 'Instagram' : /FBAN|FBAV|FB_IAB/.test(ua) ? 'Facebook'
          : /musical_ly|BytedanceWebview|TikTok/i.test(ua) ? 'TikTok' : /\bLine\//i.test(ua) ? 'LINE'
          : /Twitter/i.test(ua) ? 'X' : /Pinterest/i.test(ua) ? 'Pinterest' : '';
        Q.push({ v: V, s: S, n: N, k: K, e: 'pv', p: P, c: C, t: (document.title || '').slice(0, 120),
                 r: ext ? ref.slice(0, 300) : (fresh ? '(なし)' : ''), q: q, w: window.innerWidth, a: STAFF ? 'staff' : app });
        // 共有されたリンクから来た（家族など、ほかに決める人の動き）。ks＝共有した人の番号
        var ks = (location.search.match(/[?&]ks=([a-z0-9]{6,40})/) || [])[1];
        if (ks && ks !== V) Q.push({ v: V, s: S, n: N, e: 'shared_open', p: P, c: C, x: { from: ks } });
        flush();
        // 共有するリンクに、共有した人の番号（ks）を付ける。LINEで送る・コピー・端末の共有の3つ。
        // 付けられなくても、共有そのものはそのまま行う
        function mark(t) {
          try {
            return String(t).replace(/https:\/\/kidomeimoku\.co\.jp\/[^\s"'<>]*/g, function (u) {
              return /[?&]ks=/.test(u) ? u : u + (u.indexOf('?') < 0 ? '?' : '&') + 'ks=' + V;
            });
          } catch (e) { return t; }
        }
        try {
          var oo = window.open;
          if (typeof oo === 'function' && !oo.__kt) {
            var wo = function (u) {
              try {
                if (typeof u === 'string' && /^https:\/\/line\.me\/R\/msg\/text\/\?/.test(u)) {
                  var i = u.indexOf('?'); arguments[0] = u.slice(0, i + 1) + encodeURIComponent(mark(decodeURIComponent(u.slice(i + 1))));
                }
              } catch (e) {}
              return oo.apply(this, arguments);
            };
            wo.__kt = 1; window.open = wo;
          }
          var cb = navigator.clipboard;
          if (cb && typeof cb.writeText === 'function' && !cb.writeText.__kt) {
            var ow = cb.writeText.bind(cb), ww = function (t) { var m = t; try { m = mark(t); } catch (e) {} return ow(m); };
            ww.__kt = 1; cb.writeText = ww;
          }
          if (typeof navigator.share === 'function' && !navigator.share.__kt) {
            var os = navigator.share.bind(navigator), ws = function (d) {
              try { if (d) { d = Object.assign({}, d); if (d.url) d.url = mark(d.url); if (d.text) d.text = mark(d.text); } } catch (e) {}
              return os(d);
            };
            ws.__kt = 1; navigator.share = ws;
          }
        } catch (e) {}
        // 来店予約サイト（kidomeimoku.shop）へ、同じ番号を引き継ぐ（2026-10-20・Issue #192）。
        // 予約は別タブの予約サイトで完了するため、番号を渡さないと「何を見て予約したか」が結べない。
        // 埋め込み枠には尋ねられたら返す／直接のリンクには押したときに添える
        // ※ 2026-10-24 時点で本番に出ていない（予約リンクの書き換えはお客様の画面の変更＝別に承認を取る）。
        //    承認が取れたら RSV_LINK を true にする
        var RSV_LINK = false;
        if (RSV_LINK) try {
          var RS = 'https://kidomeimoku.shop', kid = { type: 'kt_id', v: V, s: S, n: N };
          window.addEventListener('message', function (ev) {
            try {
              if (ev.origin === RS && ev.data && ev.data.type === 'kt_hello' && ev.source) ev.source.postMessage(kid, RS);
            } catch (e) {}
          });
          var fr = document.querySelectorAll('iframe[src^="' + RS + '"]');
          for (var i = 0; i < fr.length; i++) { try { fr[i].contentWindow.postMessage(kid, RS); } catch (e) {} }
          document.addEventListener('click', function (ev) {
            try {
              var a = ev.target && ev.target.closest ? ev.target.closest('a[href^="' + RS + '"]') : null;
              var h = a && a.getAttribute('href');
              if (!h || /[?&]kt_v=/.test(h)) return;
              var k = h.indexOf('#'), tail = k < 0 ? '' : h.slice(k); h = k < 0 ? h : h.slice(0, k);
              a.setAttribute('href', h + (h.indexOf('?') < 0 ? '?' : '&') + 'kt_v=' + V + '&kt_s=' + S + '&kt_n=' + N + tail);
            } catch (e) {}
          }, true);
        } catch (e) {}
        // 問い合わせ・相談のフォームを送った（中身は読まない。どのフォームかだけ）。
        // 届いたメールと送った時刻で結び、返信の前に「この方が見ていた板」を担当に見せる
        document.addEventListener('submit', function (ev) {
          try {
            var f = ev.target, id = (f && (f.id || f.getAttribute('data-id') || (f.closest && f.closest('[data-id]') && f.closest('[data-id]').getAttribute('data-id')) || f.getAttribute('action') || '')) || '';
            log('form_send', { form: String(id).slice(0, 60) }); flush();
          } catch (e) {}
        }, true);
        // サイトがGA4へ送っている操作（お気に入り・共有・相談・予約など）を、そのまま写す。
        // gtag を包むだけで、GA4への送信は前と同じに行う
        var og = window.gtag;
        if (typeof og === 'function' && !og.__kt) {
          var w = function () {
            try {
              if (arguments[0] === 'event' && arguments[1] && !/^(page_view|view_item|add_to_cart)$/.test(arguments[1])) {
                var a = arguments[2] || {}, x = {};
                ['item_id', 'item_name', 'item_count', 'location', 'method', 'label', 'action', 'form', 'handle']
                  .forEach(function (k) { if (a[k] != null) x[k] = String(a[k]).slice(0, 80); });
                log(String(arguments[1]).slice(0, 40), x);
              }
            } catch (e) {}
            return og.apply(this, arguments);
          };
          w.__kt = 1; window.gtag = w;
        }
        // カートに入れた・数を変えた（サイトの通信を横から見るだけ。中身には触らない）
        if (window.PerformanceObserver) {
          var stamped = g('kt_cart') === S;
          new PerformanceObserver(function (l) {
            try {
              l.getEntries().forEach(function (en) {
                var m = /\/cart\/(add|change|update|clear)(\.js)?/.exec(en.name || '');
                if (!m || /kt_v/.test(en.name)) return;
                log('cart_' + m[1]);
                // 注文と結びつけるため、カートに番号を1回だけ書いておく（注文の「追加の詳細」に残る）
                if (m[1] === 'add' && !stamped) {
                  stamped = true; s('kt_cart', S);
                  fetch('/cart/update.js?kt_v=1', { method: 'POST', keepalive: true,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: { kt_v: V } }) }).catch(function () {});
                }
              });
            } catch (e) {}
          }).observe({ type: 'resource', buffered: false });
        }
        // 見ていた時間（画面に出ていた秒数）を、離れるとき（隠れた・閉じた）に送る
        var seen = 0, since = document.visibilityState === 'visible' ? Date.now() : 0, sentAt = -1;
        var D = V2 ? detail() : null;
        function bye() {
          try {
            if (since) { seen += Date.now() - since; since = 0; }
            var sec = Math.round(seen / 1000);
            if (sec !== sentAt) { sentAt = sec; log('leave', { sec: sec }); }
            if (D) D.bye();
            flush();
          } catch (e) {}
        }
        document.addEventListener('visibilitychange', function () {
          try { if (document.visibilityState === 'hidden') bye(); else since = Date.now(); } catch (e) {}
        });
        window.addEventListener('pagehide', bye);
      } catch (e) {}
    }
    // ---------------------------------------------------------------- 細かい記録（V2）
    // 守り：見るだけで、ページの動きを止めない（preventDefault しない・passive）。
    //       入力欄の中身は読まない。文字は、ボタン・リンクに書かれた文字だけを短く取る
    function detail() {
      var t0 = Date.now();
      function short(t, n) { return String(t || '').replace(/\s+/g, ' ').trim().slice(0, n || 30); }
      // 区画の名前：data-kt-area → 区画の見出し → 区画のID
      function areaName(el) {
        try {
          if (el.getAttribute('data-kt-area')) return short(el.getAttribute('data-kt-area'), 24);
          var h = el.querySelector('h1,h2,h3,legend,.kdx__ttl,[class*="__title"],[class*="-title"]');
          // 商品ごとの番号（kido-gallery-9614434533634 など）は外し、どの商品でも同じ名前にする。
          // IDのある区画はIDだけ（見出しに商品名が入る区画があるため）。IDが無い区画は、部品名＋見出し
          var id = (el.id || '').replace(/^shopify-section-(template--\d+__)?/, '').replace(/[-_]?\d{6,}/g, '').replace(/^[-_]+|[-_]+$/g, '');
          var cls = (String(el.className || '').split(/\s+/)[0] || '').replace(/[-_]?\d{6,}/g, '');
          var ht = h ? short(h.innerText, 16) : '';
          return short(id ? id : (cls || 'block') + (ht ? '｜' + ht : ''), 40);
        } catch (e) { return ''; }
      }
      var AREA_SEL = '[data-kt-area],[id^="shopify-section-"],main section,.kido-gallery,.kido-opt__summary,.kfv-legcar,.kdx__spec,#kido-future,[id^="kido-"]';
      function areaOf(el) {
        try {
          var a = el.closest(AREA_SEL);
          if (!a) return /HEADER|NAV/.test((el.closest('header,nav') || {}).tagName || '') ? 'header' : '';
          return areaName(a);
        } catch (e) { return ''; }
      }
      // 何番目か：同じ形の兄弟が3つ以上並ぶ中での位置（一覧のカード・写真の並び）
      function indexOf(el) {
        try {
          // 親へたどり、同じ形（タグと最初のクラスが同じ）の兄弟が3つ以上ある所での位置
          for (var n = el, j = 0; n && n.parentElement && j < 7; n = n.parentElement, j++) {
            var c0 = String(n.className || '').split(/\s+/)[0];
            var sib = [].filter.call(n.parentElement.children, function (c) { return c.tagName === n.tagName && String(c.className || '').split(/\s+/)[0] === c0; });
            if (sib.length >= 3) return sib.indexOf(n) + 1;
          }
        } catch (e) {}
        return 0;
      }
      function dest(a) {
        try {
          var h = a.getAttribute('href') || '';
          if (/^tel:/.test(h)) return 'tel';
          if (/^mailto:/.test(h)) return 'mail';
          if (/^#/.test(h)) return h.slice(0, 30);
          var u = new URL(h, location.href);
          return u.host === location.host ? u.pathname.slice(0, 120) : (u.host + u.pathname.split('/').slice(0, 2).join('/')).slice(0, 80);
        } catch (e) { return ''; }
      }
      var CLICK_SEL = 'a[href],button,summary,[role="button"],[role="tab"],label,select,input[type="submit"],input[type="button"],input[type="checkbox"],input[type="radio"],[data-kt],[onclick]';
      function describe(el) {
        var d = { k: el.tagName.toLowerCase() + (el.type && /INPUT|BUTTON/.test(el.tagName) ? ':' + el.type : '') };
        d.a = areaOf(el);
        var lb = el.getAttribute('data-kt') || el.getAttribute('aria-label') || el.getAttribute('title') ||
                 (el.tagName === 'SELECT' ? (el.name || '') : el.innerText) || el.getAttribute('alt') || ((el.querySelector && el.querySelector('img[alt]')) || {}).alt || '';
        d.l = short(lb, 30);
        if (el.tagName === 'A') d.h = dest(el);
        var i = indexOf(el); if (i) d.i = i;
        return d;
      }
      // 1. すべての押下
      var last = [], rageDone = {}, plainN = 0;
      document.addEventListener('click', function (ev) {
        try {
          var tg = ev.target && ev.target.closest ? ev.target : null; if (!tg) return;
          var el = tg.closest(CLICK_SEL);
          // 印の無い部品でも、指のマークになる所は押せる所として扱う（写真の小さな一覧など）
          if (!el) { for (var up = tg, j = 0; up && up !== document.body && j < 6; up = up.parentElement, j++) { if (getComputedStyle(up).cursor === 'pointer') { el = up; break; } } }
          var now = Date.now();
          if (!el) {
            // 押しても何も起きない写真を押した（拡大できると思われている）
            var img = tg.closest('img,picture,video');
            if (img && plainN < 10) { plainN++; log('tap_plain', { k: img.tagName.toLowerCase(), a: areaOf(img), i: indexOf(img) || undefined, l: short(img.getAttribute('alt'), 30) }); }
            return;
          }
          // label を押すと、中の入力欄の押下が続けて起きる。2回に数えない
          if (/INPUT/.test(el.tagName) && lastClick && now - lastClick.t < 150 && /^label/.test(lastClick.d.k)) return;
          var d = describe(el);
          log('click', d);
          // 2. 連打：同じ所を1秒以内に3回（写真送り・数の増減など、続けて押すのが普通の所は除く）
          last.push({ t: now, x: ev.clientX, y: ev.clientY });
          last = last.filter(function (o) { return now - o.t < 1000 && Math.abs(o.x - ev.clientX) < 30 && Math.abs(o.y - ev.clientY) < 30; });
          var key = d.a + '|' + d.l;
          var ok = /next|prev|arrow|swiper|slick|slider|carousel|thumb|zoom|qty|quantity|plus|minus/i.test(String(el.className || '') + ' ' + (el.getAttribute('aria-label') || '')) || /^[‹›<>＋－+\-]$/.test(d.l);
          if (last.length >= 3 && !rageDone[key] && !ok) { rageDone[key] = 1; log('rage_click', d); }
          // 3. 押しても何も起きない：1.2秒のあいだ、画面の変化・通信・移動・スクロールが無い
          if (el.tagName !== 'SELECT' && el.tagName !== 'LABEL' && !/INPUT/.test(el.tagName) && window.MutationObserver) {
            var changed = false, url = location.href, sy = window.scrollY, nres = performance.getEntriesByType ? performance.getEntriesByType('resource').length : 0;
            var mo = new MutationObserver(function () { changed = true; });
            mo.observe(document.body, { subtree: true, childList: true, attributes: true, characterData: true });
            setTimeout(function () {
              try {
                mo.disconnect();
                var nres2 = performance.getEntriesByType ? performance.getEntriesByType('resource').length : 0;
                if (!changed && url === location.href && Math.abs(window.scrollY - sy) < 5 && nres2 === nres && document.visibilityState === 'visible') log('dead_click', d);
              } catch (e) {}
            }, 1200);
          }
          lastClick = { t: now, d: d };
        } catch (e) {}
      }, { capture: true, passive: true });
      document.addEventListener('change', function (ev) {
        try {
          var el = ev.target; if (!el || el.tagName !== 'SELECT') return;
          var d = describe(el); d.l = short((el.options[el.selectedIndex] || {}).text, 30); log('select', d);
        } catch (e) {}
      }, true);
      // 4. エラー（直前の押下も添える）。1ページ5件まで
      var lastClick = null, errN = 0;
      window.addEventListener('error', function (ev) {
        try {
          if (errN >= 5) return; errN++;
          // 画像などの読み込み失敗（message が無い）
          var tgt = ev.target;
          if (!ev.message && tgt && tgt !== window && tgt.tagName) {
            log('load_error', { k: tgt.tagName.toLowerCase(), f: short(String(tgt.currentSrc || tgt.src || tgt.href || '').split('/').pop().split('?')[0], 60), a: areaOf(tgt) });
            return;
          }
          var x = { m: short(ev.message, 100), f: short(String(ev.filename || '').split('/').pop().split('?')[0], 40), ln: ev.lineno || 0 };
          if (lastClick && Date.now() - lastClick.t < 3000) { x.after = lastClick.d.a + '｜' + lastClick.d.l; }
          log('js_error', x);
        } catch (e) {}
      }, true);
      // 5. 見えた区画：区画の高さ（画面より高いときは画面の高さ）の半分以上が1秒続けて見えたら1回。
      //    離れるときに、区画ごとに見えていた秒数も送る
      var areas = [], vis = {}, secs = {}, seenOnce = {};
      try {
        var cand = document.querySelectorAll(AREA_SEL);
        for (var i = 0; i < cand.length && areas.length < 40; i++) {
          var r = cand[i].getBoundingClientRect();
          if (r.height >= 80 && r.width >= 100) areas.push(cand[i]);
        }
      } catch (e) {}
      function tick(name, on) {
        var now = Date.now();
        if (on && !vis[name]) {
          vis[name] = now;
          setTimeout(function () {
            try { if (vis[name] && !seenOnce[name] && Date.now() - vis[name] >= 950) { seenOnce[name] = 1; log('seen', { a: name, t: Math.round((Date.now() - t0) / 1000) }); } } catch (e) {}
          }, 1000);
        } else if (!on && vis[name]) {
          secs[name] = (secs[name] || 0) + (now - vis[name]); vis[name] = 0;
        }
      }
      if (window.IntersectionObserver && areas.length) {
        var names = new Map();
        var io = new IntersectionObserver(function (es) {
          try {
            es.forEach(function (en) {
              var nm = names.get(en.target); if (!nm) return;
              var base = Math.min(en.boundingClientRect.height, window.innerHeight) || 1;
              tick(nm, en.isIntersecting && en.intersectionRect.height / base >= 0.5);
            });
          } catch (e) {}
        }, { threshold: [0, 0.1, 0.25, 0.4, 0.5, 0.6, 0.75, 0.9, 1] });
        areas.forEach(function (a) { var nm = areaName(a); if (nm) { names.set(a, nm); io.observe(a); } });
      }
      // 6. 表示の速さ（お客様の端末で測った値）
      var vit = { lcp: 0, cls: 0, inp: 0 };
      try {
        if (window.PerformanceObserver) {
          try { new PerformanceObserver(function (l) { l.getEntries().forEach(function (en) { vit.lcp = Math.round(en.startTime); }); }).observe({ type: 'largest-contentful-paint', buffered: true }); } catch (e) {}
          try { new PerformanceObserver(function (l) { l.getEntries().forEach(function (en) { if (!en.hadRecentInput) vit.cls += en.value; }); }).observe({ type: 'layout-shift', buffered: true }); } catch (e) {}
          try { new PerformanceObserver(function (l) { l.getEntries().forEach(function (en) { if (en.interactionId && en.duration > vit.inp) vit.inp = Math.round(en.duration); }); }).observe({ type: 'event', buffered: true, durationThreshold: 40 }); } catch (e) {}
        }
      } catch (e) {}
      var vitSent = false, maxDepth = 0, maxPx = 0, lastSec = '', lastDepth = -1;
      window.addEventListener('scroll', function () { try { maxPx = Math.max(maxPx, window.scrollY + window.innerHeight); } catch (e) {} }, { passive: true });
      return {
        bye: function () {
          try {
            var now = Date.now(), m = {}, n = 0;
            Object.keys(vis).forEach(function (k) { if (vis[k]) { secs[k] = (secs[k] || 0) + (now - vis[k]); vis[k] = now; } });
            Object.keys(secs).sort(function (a, b) { return secs[b] - secs[a]; }).forEach(function (k) {
              var sec = Math.round(secs[k] / 1000); if (sec >= 1 && n < 14) { m[k.slice(0, 24)] = sec; n++; }
            });
            // 隠れるたびに累計を送り直すので、前と同じ中身なら送らない（集計は1回の開きごとに最後の1件を使う）
            var ms = JSON.stringify(m);
            if (n && ms !== lastSec) { lastSec = ms; log('area_sec', m); }
            // どこまで下に見たか（ページの長さに対する割合）
            try {
              var hgt = document.documentElement.scrollHeight || 1; maxPx = Math.max(maxPx, window.scrollY + window.innerHeight); maxDepth = Math.min(1, maxPx / hgt);
              var dp = Math.round(maxDepth * 100);
              if (dp !== lastDepth) { lastDepth = dp; log('depth', { d: dp, px: Math.round(maxPx) }); }
            } catch (e) {}
            if (!vitSent) {
              vitSent = true;
              var nv = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
              var fcp = (performance.getEntriesByName && performance.getEntriesByName('first-contentful-paint')[0]) || {};
              log('vitals', { lcp: vit.lcp || undefined, fcp: Math.round(fcp.startTime || 0) || undefined, ttfb: Math.round(nv.responseStart || 0) || undefined,
                              cls: Math.round(vit.cls * 1000) / 1000, inp: vit.inp || undefined, kb: Math.round((nv.transferSize || 0) / 1024) || undefined });
            }
          } catch (e) {}
        }
      };
    }
    if (window.requestIdleCallback) requestIdleCallback(start, { timeout: 4000 });
    else setTimeout(start, 1500);
  } catch (e) {}
})();
